export default function convertToJson(obj) {
  return Object.entries(obj) // Create array from object
    .map(([key, value]) => [
      // change key to remove '_'
      key.startsWith("_") ? key.substring(1) : key,
      value,
    ])
    .reduce((acc, [key, value]) => {
      // Transform back to object
      acc[key] = value;
      return acc;
    }, {});
}
